import { hotlineProfessionalDetailText } from '@/feature/hotline/professional/detail/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineProfessionalDetailText;
const numberRegex = /^[0-9]+$/;
const messageMaxText = '桁が多すぎます。入力内容をご確認ください';
/**
 * 匿名コンサルホットライン 日程申請受諾フォーム schema
 */
export const hotlineProScheduleRequestFormCommon = {
    /**
     * Web会議がつながらないときの電話番号 1つ目
     */
    phone1: z
        .string({ required_error: messages.required(label.phone()) })
        .regex(numberRegex, messages.halfWidthNumber())
        .max(4, messageMaxText)
        .min(1, messages.required(label.phone())),
    /**
     * Web会議がつながらないときの電話番号 2つ目
     */
    phone2: z
        .string({ required_error: messages.required(label.phone()) })
        .regex(numberRegex, messages.halfWidthNumber())
        .max(4, messageMaxText)
        .min(1, messages.required(label.phone())),
    /**
     * Web会議がつながらないときの電話番号 3つ目
     */
    phone3: z
        .string({ required_error: messages.required(label.phone()) })
        .regex(numberRegex, messages.halfWidthNumber())
        .max(4, messageMaxText)
        .min(1, messages.required(label.phone())),
};
/**
 * 匿名コンサルホットライン 日程申請受諾フォーム schema
 */
export const hotlineProScheduleRequestFormSchema = z.object(Object.assign(Object.assign({}, hotlineProScheduleRequestFormCommon), { 
    /**
     * 当日のタイムスケジュール
     */
    timeSchedule: z
        .string({ required_error: messages.required(label.timeSchedule()) })
        .min(1, messages.required(label.timeSchedule()))
        .max(10000, messages.maxLength(10000, label.timeSchedule())) }));
/**
 * 匿名コンサルホットライン 日程申請受諾フォーム（更新用） schema
 */
export const hotlineProScheduleRequestUpdateFormSchema = z.object(hotlineProScheduleRequestFormCommon);
